import { ITableSettings } from '@components/Table/types';
import { NotificationFormatter } from '@pages/Appointment/utils/notificationFormatter';
import { FirstNotificationFormatter } from '@pages/Appointment/utils/firstNotificationFormatter';
import { SecondNotificationFormatter } from '@pages/Appointment/utils/secondNotificationFormatter';
import { VisitDateFormatter } from '@pages/Trial/components/utils/visitDateFormatter';

export const tableSettings: ITableSettings<any>[] = [
  {
    accessor: 'name',
    title: 'Appointment name',
  },
  {
    accessor: 'type',
    title: 'Type',
  },
  {
    accessor: 'protocolWindow',
    title: 'Protocol window',
    formatter: VisitDateFormatter,
  },
  {
    accessor: 'date',
    title: 'Date',
  },
  {
    accessor: 'time',
    title: 'Time',
  },
  {
    accessor: 'notificationsSettings',
    title: 'Send notification using',
    formatter: NotificationFormatter,
  },
  {
    accessor: 'first',
    title: 'First notification',
    formatter: FirstNotificationFormatter,
  },
  {
    accessor: 'second',
    title: 'Second notification',
    formatter: SecondNotificationFormatter,
  },
];
